// utils/MUX/api.js
import axios from 'axios';

// Mux API base URL
const MUX_API_BASE_URL = 'https://api.mux.com';

// Create a separate axios instance for Mux
const muxApi = axios.create({
  baseURL: MUX_API_BASE_URL,
  timeout: 30000, // Longer timeout for video operations
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth interceptor for Mux API
muxApi.interceptors.request.use(
  (config) => {
    // Mux uses Basic Auth with tokenId:tokenSecret
    const tokenId = process.env.NEXT_PUBLIC_MUX_TOKEN_ID;
    const tokenSecret = process.env.NEXT_PUBLIC_MUX_TOKEN_SECRET;
    
    if (tokenId && tokenSecret) {
      const authToken = Buffer.from(`${tokenId}:${tokenSecret}`).toString('base64');
      config.headers.Authorization = `Basic ${authToken}`;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

export default muxApi;